import { Component } from "react";

interface IContextMenuOverlayProps {
    children: React.ReactNode;
}

export class ContextMenuOverlay extends Component<IContextMenuOverlayProps> {
    private stopPropagation = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.stopPropagation();
    };

    render() {
        return (
            <div onContextMenu={this.stopPropagation} onDoubleClick={this.stopPropagation}>
                {this.props.children}
            </div>
        );
    }
}
